import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {device} from 'styled/device';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  padding: 0 20px;
`;
export const RegistrationIcon = styled.img`
  margin: 0 auto 25px;
  display: block;
  width: 200px;
  height: 200px;
`;

export const Title = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.36px;
  color: #152946;
  margin-bottom: 8px;
  /* @media (min-width: ${device.tablet}) {
    margin-bottom: 48px;
  } */
`;

export const SubTitle = styled.div`
  font-style: normal;
  /* font-weight: 700; */
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #152946;
  margin: 0 auto 72px;

  @media (min-width: ${device.tablet}) {
    width: 100%;
    /* margin: 0 auto; */
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    max-width: 320px;
    margin: 0 auto 48px;
  }
`;

export const RegisterBottom = styled(Link)`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    radial-gradient(50% 50% at 50% 50%, #5573ff 0%, #4441e9 100%);
  border-radius: 50px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  padding: 15px;
  text-align: center;
  letter-spacing: -0.15px;
  margin-bottom: 35px;
  display: block;
  @media (min-width: ${device.tablet}) {
    width: 295px;
    margin: 0 auto 46px;
  }
`;

export const ShareRegistrationLinkButton = styled.div`
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.15px;
  text-align: center;
  color: #393abd;
  font-weight: 500;
  margin-bottom: 60px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 0.8;
    transition: opacity 0.2s ease;
  }
`;

export const ButtonsWrapper = styled.div`
  /* position: absolute; */
  /* bottom: 50px; */
  /* left: 50%; */
  width: 290px;
  margin-top: 24px;
  /* transform: translateX(-50%); */
  /* @media (min-width: ${device.tablet}) {
    margin-top: 24px;
    /* position: relative; */
    /* bottom: auto; */
    /* left: auto; */
    /* transform: none; */
    /* margin: 0 auto; */
  } */
`;

export const GuestListTitle = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 24px;
  text-align: center;
  display: flex;
  gap: 8px;
  @media (min-width: ${device.tablet}) {
    margin-bottom: 32px;
  }
`;

export const GuestPanelContainer = styled.div`
  margin-bottom: 48px;
`;

export const EditIcon = styled.div`
  cursor: pointer;
`;
